module.exports = __webpack_public_path__ + "./img-alan_b25d89dc53f67c9888232d853f443976.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2018/img-alan.png
// module id = 460
// module chunks = 0